import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {SingleMultiplicationModel} from '../../../../../models/questions/subModels/singleMultiplication.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-single-multiplication',
  templateUrl: './evo-single-multiplication.component.html',
  styleUrls: ['./evo-single-multiplication.component.css']
})
export class EvoSingleMultiplicationComponent implements OnInit {

  Enums = Enums;
  // QuestionModel = QuestionModel;
  @Input() question: QuestionModel = new SingleMultiplicationModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): SingleMultiplicationModel {

    return <SingleMultiplicationModel>this.question;
  }

  getOutcomeString(): string {

    const minOutcome = this.castedQuestion().model.firstRange.minValue() * this.castedQuestion().model.secondRange.minValue();
    const maxOutcome = this.castedQuestion().model.firstRange.maxValue() * this.castedQuestion().model.secondRange.maxValue();

    return `[${minOutcome}, ${maxOutcome}]`;

  }

  showQuestion(): boolean {

    if (this.question.subCategory === Enums.QuestionSubcategories.singleMultiplication) {

      return true;
    }

    return false;
  }

}
